import { CircularProgress, Pagination, Button } from "@mui/material";

import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { Box, Typography } from "@mui/material";
import TableForm from "../../../../components/Backend/TableForm/TableForm";
import ActionCellForList from "../../../../components/Backend/ActionCellForList";
import ReadOnlyQuill from "../../../../components/Backend/Admin/Marketing/ReadOnlyQuill";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useDebouncedApiCall from "../../../../customHooks/DebounceApi/useDebounceApi";
import { FetchErrorLogAsync } from "../../../../redux/thunk/ErrorLog";

const errorLogs = [
  {
    userId: 1,
    logs: "Connection Reset Error",
    pageRoute: "/admin/orders",
    browser: "Chrome/Windows",
    userAgent:
      "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36...",
    createdAt: "2025-05-23 15:39:46",
    updatedAt: "2025-05-23 15:39:46",
  },
];

function List() {
  const { errorLogList, errorLogListStatus } = useSelector(
    (state) => state.errorLog
  );

  const dispatch = useDispatch();
  let [page, setPage] = useState(1);
  let [searchValue, setSearchValue] = useState("");

  //Call Backend APIs
  let postPath = "error-logs?page=" + page;
  //let userNamePath ="username_by_id"+ "id=" +id;
  let searchPath = "search-error-log?page=" + page + "&error=" + searchValue;

  const { setDebouncedValue } = useDebouncedApiCall(
    (spath) => FetchErrorLogAsync({ path: spath }),
    1000
  );
  useEffect(() => {
    if (searchValue !== "") {
      setDebouncedValue(searchPath);
    } else {
      dispatch(FetchErrorLogAsync({ path: postPath }));
      setDebouncedValue(null);
    }
  }, [dispatch, postPath, page, searchValue, searchPath, setDebouncedValue]);

  let handleChange = (event, p) => {
    setPage(p);
  };

  var post_html_table = "";
  var paging_html = "";

  const backendURL = process.env.REACT_APP_BACKEND_ADMIN + "error-logs";

  const ellipsisStyle = {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    width: "350px",
    maxWidth: "350px",
  };

  if (errorLogListStatus === "loading") {
    post_html_table = (
      <TableRow>
        <TableCell colSpan="12">
          <Box
            sx={{
              textAlign: "center",
              width: "100%",
              height: "60vh",
              py: "20vh",
            }}
          >
            <CircularProgress />
          </Box>
        </TableCell>
      </TableRow>
    );
  }

  if (errorLogListStatus === "failed") {
    post_html_table = (
      <TableRow>
        <TableCell colSpan="12" height="60vh">
          <Typography
            variant="h5"
            textAlign="center"
            sx={{ py: "20vh", color: "red" }}
          >
            Fail to fetch data
          </Typography>
        </TableCell>
      </TableRow>
    );
  } else {
    if (errorLogListStatus === "succeeded" && errorLogList.data !== undefined) {
      post_html_table = errorLogList.data.map((item, index) => {
        return (
          <TableRow
            id={item.id}
            key={index}
            sx={{
              "&:last-child td, &:last-child th": { border: 0 },
              height: "20%",
              overflow: "hidden",
            }}
            height={"60px"}
          >
            <TableCell sx={{ ...ellipsisStyle, width: "10%" }}>
              {item.user_id}
            </TableCell>
            <TableCell sx={{ ...ellipsisStyle, width: "10%" }}>
              {item.user?.name}
            </TableCell>
            <TableCell
              sx={{
                width: "20%",
                textAlign: "center",
                maxWidth: "300px", // Constrain width
                overflow: "hidden", // Hide overflow
                position: "relative", // For absolute positioning of tooltip if needed
              }}
            >
              <Box
                sx={{
                  maxHeight: "150px", // Limit height
                  overflow: "auto", // Enable scrolling
                  whiteSpace: "pre-wrap", // Preserve line breaks
                  fontFamily: "monospace", // Better for logs
                  p: 1,
                  backgroundColor: "#f5f5f5",
                  borderRadius: "4px",
                  "&::-webkit-scrollbar": {
                    width: "6px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#888",
                    borderRadius: "3px",
                  },
                }}
              >
                {typeof item.logs === "string"
                  ? item.logs
                  : JSON.stringify(item.logs, null, 2)}
              </Box>
            </TableCell>
            <TableCell sx={{ ...ellipsisStyle, width: "10%" }}>
              {item.page_route}
            </TableCell>
            <TableCell
              sx={{ ...ellipsisStyle, width: "20%", textAlign: "center" }}
            >
              {item.browser}
            </TableCell>
            <TableCell
              sx={{ ...ellipsisStyle, width: "20%", textAlign: "center" }}
            >
              {item.user_agent}
            </TableCell>
            <TableCell
              sx={{ ...ellipsisStyle, width: "20%", textAlign: "center" }}
            >
              {item.created_at}
            </TableCell>
            {/* <TableCell
              sx={{ ...ellipsisStyle, width: "20%", textAlign: "center" }}
            >
              {item.updated_at}
            </TableCell> */}
            {/* <TableCell
                sx={{ ...ellipsisStyle, width: "30%", textAlign: "center" }}
              >
                <img
                  style={{ width: "100%", minHeight: "5rem", minWidth: "6rem" }}
                  src={`${process.env.REACT_APP_BACKEND_URL}storage/email_template/${item.img_header}`}
                  alt=""
                />
              </TableCell> */}
            <ActionCellForList item={item} editExist={false} url={backendURL} />
          </TableRow>
        );
      });
    }
  }
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            ml: "2rem",
            top: "1rem",
            position: "absolute",
            overflow: "visible",
            zIndex: 1500,
          }}
        >
          <Typography variant="h5">Error Logs</Typography>
        </Box>
        <TableForm
          tableSection="error_logs"
          pagingHtml={paging_html}
          postHtmlTable={post_html_table}
          setPage={setPage}
          setSearchValue={setSearchValue}
        ></TableForm>
        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            my: 2,
          }}
        >
          <Pagination
            size="large"
            count={errorLogList.last_page}
            color="primary"
            page={page}
            onChange={handleChange}
          />
        </Box>
      </Box>
    </>
  );
}
export default List;
